var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8.32639,
    fill: "#ECF0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3337 17.4428C28.3337 16.938 28.3337 16.6856 28.2338 16.5687C28.1472 16.4673 28.0173 16.4134 27.8843 16.4239C27.7311 16.436 27.5526 16.6144 27.1956 16.9714L24.167 20L27.1956 23.0286C27.5526 23.3856 27.7311 23.5641 27.8843 23.5761C28.0173 23.5866 28.1472 23.5328 28.2338 23.4314C28.3337 23.3145 28.3337 23.0621 28.3337 22.5572V17.4428Z",
    stroke: "#5D82DB",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 18.1667C11.667 16.7666 11.667 16.0665 11.9395 15.5317C12.1792 15.0613 12.5616 14.6789 13.032 14.4392C13.5668 14.1667 14.2669 14.1667 15.667 14.1667H20.167C21.5671 14.1667 22.2672 14.1667 22.802 14.4392C23.2724 14.6789 23.6548 15.0613 23.8945 15.5317C24.167 16.0665 24.167 16.7666 24.167 18.1667V21.8334C24.167 23.2335 24.167 23.9336 23.8945 24.4683C23.6548 24.9387 23.2724 25.3212 22.802 25.5609C22.2672 25.8334 21.5671 25.8334 20.167 25.8334H15.667C14.2669 25.8334 13.5668 25.8334 13.032 25.5609C12.5616 25.3212 12.1792 24.9387 11.9395 24.4683C11.667 23.9336 11.667 23.2335 11.667 21.8334V18.1667Z",
    stroke: "#5D82DB",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.5d66f821069394cb7879055389e5caa3.svg";
export { ForwardRef as ReactComponent };